<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark>mdi-arrow-left</v-icon>
          </v-btn>
          Edit Agency
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.unique_id"
                outlined
                label="Enter User ID"
                prepend-inner-icon="mdi-account-key"
                disabled
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.name"
                outlined
                label="Agency Name"
                prepend-inner-icon="mdi-account-group"
              ></v-text-field>
            </v-col>

            <v-col sm="4">
              <v-text-field
                v-model="form.whatsapp_no"
                outlined
                label="WhatsApp Number"
                prepend-inner-icon="mdi-whatsapp"
              ></v-text-field>
            </v-col>

            <v-col sm="4">
              <input
                type="file"
                id="file"
                name="file"
                :ref="`file`"
                @change="onFileChange"
              />
              <v-btn
                x-small
                class="reset_image my-1"
                color="red"
                dark
                @click="($refs.file.value = null), (agency_path = null)"
              >
                Remove
              </v-btn>

              <div id="preview" v-if="agency_path" class="mt-5">
                <label for="">Image Preview</label>
                <br />
                <img :src="agency_path" style="height: 30%; width: 30%" />
              </div>
            </v-col>

            <v-col sm="4">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_active"
                inset
                :label="`Is Active: ${form.is_active ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
          </v-row>

          <v-divider class="my-5" />

          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Update Agency
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";

export default {
  name: "AgencyIdPage",
  data() {
    return {
      form: {},
      isLoading: false,
      agency_path: "",
      old_json: null,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      const encryptedId = this.$route.params.agencyId;
      try {
        const response = await axios.get(`/agencies/${encryptedId}`);
        this.form = response.data.data;
        this.form.unique_id = response.data.data.owner.unique_id;
        this.old_json = { ...response.data.data };
        if (this.form.agency_path) {
          this.agency_path = this.mediaUrl + this.form.agency_path;
        }
      } catch (error) {
        console.error("Error fetching agency data:", error);
      }
      this.isLoading = false;
    },

    async save() {
      try {
        this.isLoading = true;
        const response = await axios.patch(
          `/agencies/${this.$route.params.agencyId}`,
          this.form
        );
        this.updatedAgency = response.data.data;

        await this.handleFileUpload();
        await this.saveUserTimestamp(this.old_json, this.form);

        this.isLoading = false;
      } catch (error) {
        console.error("Error updating agency:", error);
        this.isLoading = false;
      }
    },

    async handleFileUpload() {
      if (this.$refs.file && this.$refs.file.files.length > 0) {
        const file = this.$refs.file.files[0];
        const formData = new FormData();
        formData.append("id", this.updatedAgency.id);
        formData.append("agency_path", file);
        try {
          await axios.post("/upload_agency_image", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });
        } catch (error) {
          console.log("Image upload failed:", error);
        }
      }
    },

    onFileChange() {
      this.file = this.$refs.file?.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(this.file);
      reader.onload = (evt) => {
        const img = new Image();
        img.onload = () => {
          this.agency_path = URL.createObjectURL(this.file);
        };
        img.src = evt.target.result;
      };
      reader.onerror = (evt) => {
        console.error("Error reading image:", evt);
      };
    },

    async saveUserTimestamp(oldData, newData) {
      try {
        const form = {
          from_path: `/agencies/${this.form.id}`,
          from_name: "AgencyIdPage",
          user_id: this.user?.id || null, // Optional
          old_json: JSON.stringify(oldData),
          new_json: JSON.stringify(newData),
        };
        await axios.post("/user_timestamps", form);
        this.$router.push("/agencies");
      } catch (error) {
        console.log("Timestamp save failed:", error);
      }
    },
  },
};
</script>
